type PackageLinkedItem = {
  id?: string | number;
  type?: string;
  dynamicPackage?: string | null;
  packageBasketItemId?: number | null;
  packageOrderItemId?: number | null;
  bookable?: { rate?: string | null } | null;
};

export type PackageNames = Map<string, string>;

export const packageNamesByRoomId = (items: unknown): PackageNames =>
  new Map(
    (Array.isArray(items) ? (items as PackageLinkedItem[]) : []).flatMap((item) =>
      item?.type === 'rooms' && item.bookable?.rate
        ? [[String(item.id), item.bookable.rate] as [string, string]]
        : []
    )
  );

const packageNameOf = (
  item: PackageLinkedItem,
  names: PackageNames | undefined
): string | undefined => {
  if (item.dynamicPackage !== 'child' || !names) return undefined;
  const roomId = item.packageBasketItemId ?? item.packageOrderItemId;
  return roomId != null ? names.get(String(roomId)) : undefined;
};

export const spaDayTitle = (
  item: PackageLinkedItem,
  names: PackageNames | undefined,
  spaDayName: string
): { title: string; spaDayLine?: string } => {
  const packageName = item.type === 'spa-packages' ? packageNameOf(item, names) : undefined;
  return {
    title: packageName ?? spaDayName,
    spaDayLine: packageName && packageName !== spaDayName ? spaDayName : undefined,
  };
};
